import PropTypes from 'prop-types'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
  TableFooter
} from 'material-ui/Table'
import PaginationFooter from 'components/pagination/components/pagination-footer'
import TableRownColumnUnclickable from 'components/table-row-column-unclickable'
import DeleteIcon from 'images/icn-trash-bin.svg'
import IconButton from 'material-ui/IconButton'
import intl from 'react-intl-universal'
import { ProductionPlanningOrigin } from 'enum/index'

const FamilyList = ({ data, countData, refreshSearch, handleEdit, handleDelete, qtRegsPerPage, profileAdminOrMasterData }) => (
  <Table
    fixedHeader
    fixedFooter
    multiSelectable={false}
    selectable={false}
    wrapperStyle={{ height: '100%' }}
    bodyStyle={{ height: 'calc(100% - 110px)', borderTop: '1px solid rgb(224, 224, 224)', backgroundColor: 'var(--color-contrast-white)' }}
    onCellClick={handleEdit}>
    <TableHeader
      displaySelectAll={false}
      adjustForCheckbox={false}
      enableSelectAll={false}
      style={{ borderBottom: 'none' }}>
      <TableRow style={{ borderBottom: 'none' }}>
        <TableHeaderColumn >{intl.get('commons.wallet')}</TableHeaderColumn>
        <TableHeaderColumn >{intl.get('master-data.general-configuration.familyName')}</TableHeaderColumn>
        <TableHeaderColumn >{intl.get('master-data.walletsAndFamilys.familys.productionNeedsSource.label')}</TableHeaderColumn>
        <TableHeaderColumn />
      </TableRow>
    </TableHeader>
    <TableBody
      displayRowCheckbox={false}
      deselectOnClickaway={false}
      showRowHover
      stripedRows={false}
    >
      {data.sort((a, b) =>
        a.Name.localeCompare(b.Name)
      ).map((v, i) => (
        <TableRow key={i} style={{ cursor: 'pointer' }}>
          <TableRowColumn>
            {v.MaterialGroup}
          </TableRowColumn>
          <TableRowColumn>
            {v.Name}
          </TableRowColumn>
          <TableRowColumn>
            {(v.ProductionNeedsSource ?? ProductionPlanningOrigin.SAP) === ProductionPlanningOrigin.DigitalDecoupling
              ? intl.get('master-data.walletsAndFamilys.familys.productionNeedsSource.digitalDecoupling')
              : intl.get('master-data.walletsAndFamilys.familys.productionNeedsSource.sap')}
          </TableRowColumn>
          <TableRownColumnUnclickable style={{ positon: 'relative', textAlign: 'right' }}>
            {profileAdminOrMasterData &&
              <div title={intl.get('master-data.walletsAndFamilys.familys.deleteFamilyModal.title')}>
                <IconButton onClick={() => handleDelete(v.Id)} >
                  <img alt='delete-icon' src={DeleteIcon} />
                </IconButton>
              </div>
            }
          </TableRownColumnUnclickable>
        </TableRow>
      ))}
    </TableBody>
    <TableFooter adjustForCheckbox={false}>
      <PaginationFooter
        countPerPage={qtRegsPerPage}
        countData={countData}
        refreshSearch={refreshSearch}
      />
    </TableFooter>
  </Table>
)

FamilyList.propTypes = {
  countData: PropTypes.number.isRequired,
  refreshSearch: PropTypes.func.isRequired,
  handleEdit: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  qtRegsPerPage: PropTypes.number.isRequired,
  profileAdminOrMasterData: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    Name: PropTypes.string,
  })).isRequired
}

export default FamilyList
